//Angular Start Up
const app = angular.module('QuartoApp', ['ui.router', 'ngResource', 'oc.lazyLoad', 'ngAnimate', 'ngCookies', 'LocalStorageModule', 'angular-loading-bar', 'ui.bootstrap', 'ngSanitize', 'stringFormatterModule', 'ngStorage', 'btorfs.multiselect']);

//@see http://192.168.0.132/blog/quarto/2021/11/17/about-chathubappversion/
//chatHubAppVersion is checked at:
//- on Quarto page loaded. (app.js)
//- every `chatHubAppVersionCheckInterval` milliseconds (app.js) - for server hot swapped dll
//- on chatHub first connected, aka login success (signalRService.js)
//- on chatHub reconnected (signalRService.js) - for server restarted
const chatHubAppVersion = null;  // chatHubAppVersion value is auto set on Quarto page loaded, DO NOT hardcode it here.

//chatHubAppVersion checking interval (milliseconds)
const chatHubAppVersionCheckInterval = 3600000;  // 1 hour

//flag to enable single hosting url set
const isSingleHost = (window?.localStorage?.getItem("isSingleHost")) !== null;

//global function to get current device timezone offset
function deviceTimezoneOffset()
{
    let DeviceTimezoneOffset = -((Math.round(((new Date().getTimezoneOffset()) / 60.00) * 100)) / 100);

    return DeviceTimezoneOffset;
}

D(() =>
{
    app.run(["$injector", function ($injector)
    {
        D.ngInject = (serviceName =>
        {
            return $injector.get(serviceName);
        });
    }]);
});

//jquery interceptor for http request made through $http to append in token in header
app.config(['$ocLazyLoadProvider', '$httpProvider', function ($ocLazyLoadProvider, $httpProvider)
{
    $ocLazyLoadProvider.config({
        loadedModules: ['oc.lazyLoad'],
        debug: false,
        events: true
    });

    $httpProvider.interceptors.push('authInterceptorService');
}]);

//configure localStorageServiceProvider to use session storage instead of local storage so that login is not preserved
app.config(function (localStorageServiceProvider)
{
    //move on to session storage instead of local storage
    localStorageServiceProvider.setStorageType('sessionStorage');
});

//load authentication from session storage
app.run(["authService", function (authService)
{
    authService.loadSession();
}]);

//custom functions
app.run(["$rootScope", function ($rootScope)
{
    $rootScope.constructor.prototype.$watchGroup = function (watchExpressions, listener)
    {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length)
        {
            // No expressions means we call the listener ASAP
            var shouldCall = true;
            self.$evalAsync(function ()
            {
                if (shouldCall) listener(newValues, newValues, self);
            });
            return function deregisterWatchGroup()
            {
                shouldCall = false;
            };
        }

        if (watchExpressions.length === 1)
        {
            // Special case size of one
            return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope)
            {
                newValues[0] = value;
                oldValues[0] = oldValue;
                listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
            });
        }

        function buildUnwatcher(expr, i)
        {
            var unwatchFn = self.$watch(expr, function watchGroupSubAction(value)
            {
                newValues[i] = value;
                if (!changeReactionScheduled)
                {
                    changeReactionScheduled = true;
                    self.$evalAsync(watchGroupAction);
                }
            });
            deregisterFns.push(unwatchFn);
        }
        for (let i = 0; i < watchExpressions.length; i++)
        {
            buildUnwatcher(watchExpressions[i], i);
        }

        function watchGroupAction()
        {
            changeReactionScheduled = false;

            try
            {
                if (firstRun)
                {
                    firstRun = false;
                    listener(newValues, newValues, self);
                } else
                {
                    listener(newValues, oldValues, self);
                }
            } finally
            {
                for (var i = 0; i < watchExpressions.length; i++)
                {
                    oldValues[i] = newValues[i];
                }
            }
        }

        return function deregisterWatchGroup()
        {
            while (deregisterFns.length)
            {
                deregisterFns.shift()();
            }
        };
    };

    String.prototype.ParseBinaryStringToExcel = function (isApplyMissingEmptyCellFixBasedOnColumnHeader)
    {
        try
        {
            var workbook = XLSX.read(this.toString(), { type: 'binary', cellDates: true }), Sheets = [];
            workbook.SheetNames.forEach(function (sheetName)
            {
                let row = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);

                if (typeof (isApplyMissingEmptyCellFixBasedOnColumnHeader) == "boolean" && isApplyMissingEmptyCellFixBasedOnColumnHeader)
                {
                    let header = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 }).shift();

                    //fill in missing cell
                    if (Array.isArray(row) && Array.isArray(header) && row.length > 0 && header.length > 0)
                    {
                        row.forEach(content =>
                        {
                            header.forEach(head =>
                            {
                                try
                                {
                                    if (typeof content[head] === "undefined")
                                    {
                                        content[head] = "";
                                    }
                                }
                                catch { }
                            });
                        });
                    }
                }

                Sheets.push(row);
            });
            return Sheets;
        }
        catch { return null; }
    };

    String.prototype.ParseBase64DocumentBytesArrayToExcel = function (filename, isXLS)
    {
        try
        {
            let data = this.toString();

            if (data != null && data.length > 0)
            {
                if (data.startsWith('"'))
                {
                    data = JSON.parse(data);
                }

                function b64toBlob(b64Data, contentType, sliceSize)
                {
                    contentType = contentType || '';
                    sliceSize = sliceSize || 512;

                    var byteCharacters = atob(b64Data);
                    var byteArrays = [];

                    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize)
                    {
                        var slice = byteCharacters.slice(offset, offset + sliceSize);

                        var byteNumbers = new Array(slice.length);
                        for (var i = 0; i < slice.length; i++)
                        {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }

                        var byteArray = new Uint8Array(byteNumbers);

                        byteArrays.push(byteArray);
                    }

                    return new Blob(byteArrays, { type: contentType });
                }

                let a = window.document.createElement('a');
                a.href = URL.createObjectURL(b64toBlob(data, 'application/vnd.ms-excel'));

                if (isXLS === true)
                {
                    a.download = typeof filename !== "string" ? "file.xls" : (filename + ".xls");
                }
                else
                {
                    a.download = typeof filename !== "string" ? "file.xlsx" : (filename + ".xlsx");
                }

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            else
            {
                return null;
            }
        }
        catch { return null; }
    }

    String.prototype.ParseBase64DocumentBytesArrayToPDF = function (fileName)
    {
        try
        {
            let data = this.toString();

            if (data != null && data.length > 0)
            {
                if (data.startsWith('"'))
                {
                    data = JSON.parse(data);
                }

                function b64toBlob(b64Data, contentType, sliceSize)
                {
                    contentType = contentType || '';
                    sliceSize = sliceSize || 512;

                    var byteCharacters = atob(b64Data);
                    var byteArrays = [];

                    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize)
                    {
                        var slice = byteCharacters.slice(offset, offset + sliceSize);

                        var byteNumbers = new Array(slice.length);
                        for (var i = 0; i < slice.length; i++)
                        {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }

                        var byteArray = new Uint8Array(byteNumbers);

                        byteArrays.push(byteArray);
                    }

                    return new Blob(byteArrays, { type: contentType });
                }

                if (fileName == "" || fileName == null || fileName == undefined) {
                    const _url = URL.createObjectURL(b64toBlob(data, 'application/pdf'));
                    window.open(_url, '_blank');
                }
                else {
                    const byteCharacters = atob(data);
                    const byteNumbers = new Array(byteCharacters.length);

                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    URL.revokeObjectURL(url);
                }
            }
            else
            {
                return null;
            }
        }
        catch { return null; }
    }

    Number.prototype.substr = function (a, b) { return this.toString().substr(a, b) };
    Number.prototype.indexOf = function (a, b) { return this.toString().indexOf(a, b) };
    Number.prototype.toLowerCase = function () { return this.toString() };
    Number.prototype.toUpperCase = function () { return this.toString() };
    Number.prototype.charAt = function (a) { return this.toString().charAt(a) };
    Number.prototype.slice = function (a, b) { return this.toString().slice(a, b) };

    String.prototype.contains = function (it) { return this.indexOf(it) != -1; };

    //quick alternative to angular.copy in angular 1.x using lodash
    Array.prototype.deepClone = function () { return _.cloneDeep(this) };

    //quick fixes
    Array.prototype.toJSON = function () { return _.cloneDeep(this) };

    //stupid hack to fix UQF
    Array.prototype.substr = function () { return ""; };

    //https://www.consolelog.io/group-by-in-javascript/
    Array.prototype.groupBy = function (prop)
    {
        return this.reduce(function (groups, item)
        {
            const val = item[prop]
            groups[val] = groups[val] || []
            groups[val].push(item)
            return groups
        }, {})
    }

    Array.prototype.SumAll = function ()
    {
        if (this.length <= 0)
        {
            console.warn("Detected empty list.");
            return 0;
        }
        return this.reduce((accumulator, currentValue) =>
        {
            if (isNaN(currentValue))
                console.error(`Detected non-numeric: ${currentValue}`);
            if (_.isString(currentValue) && currentValue.indexOf(" ") > -1)
                console.error(`Detected spaces`);
            return accumulator.Nadd(currentValue)
        }, 0);
    }

    Array.prototype.HasDuplicates = function ()
    {
        return new Set(this).size !== this.length;
    }

    Number.prototype.toFixed = function (decimals)
    {
        return new Decimal(Number(this)).toDecimalPlaces(decimals).toFixed(decimals);
    };

    Date.prototype.toJSONTZOffset = function ()
    {
        //timezone in malaysia is not always +8, you can try year 1900 - 1980 :)
        if (this.getTimezoneOffset() != (new Date()).getTimezoneOffset() && !isNaN(this.getFullYear()))
        {
            //manually construct time component
            return "" + this.getFullYear() + "-"
                + (("00" + (this.getMonth() + 1)).slice(-2)) + "-"
                + (("00" + this.getDate()).slice(-2)) + "T"
                + (("00" + this.getHours()).slice(-2)) + ":"
                + (("00" + this.getMinutes()).slice(-2)) + ":"
                + (("00" + this.getSeconds()).slice(-2)) + "Z";
        }

        //compensate for timezone as date in database such as gldate,podate are stored in user's timezone instead of utc
        return moment(this).add(this.getTimezoneOffset() * -1, 'm').utc().format();
    }

    Decimal.prototype.NabsoluteValue = Decimal.prototype.Nabs = function ()
    {
        return this.absoluteValue().toNumber();
    }

    Decimal.prototype.Nceil = function ()
    {
        return this.ceil().toNumber();
    }

    Decimal.prototype.NdividedBy = Decimal.prototype.Ndiv = function (y)
    {
        return this.dividedBy(y).toNumber();
    }

    Decimal.prototype.Nfloor = function ()
    {
        return this.floor().toNumber();
    }

    Decimal.prototype.Nminus = Decimal.prototype.Nsub = function (y)
    {
        return this.minus(y).toNumber();
    }

    Decimal.prototype.Nmodulo = Decimal.prototype.Nmod = function (y)
    {
        return this.modulo(y).toNumber();
    }

    Decimal.prototype.Nadd = Decimal.prototype.Nplus = function (y)
    {
        return this.add(y).toNumber();
    }

    Decimal.prototype.Ntimes = Decimal.prototype.Nmul = function (y)
    {
        return this.times(y).toNumber();
    }

    Decimal.prototype.NtoDecimalPlaces = Decimal.prototype.NtoDP = function (dp, rm)
    {
        return this.toDecimalPlaces(dp, rm).toNumber();
    }

    Decimal.prototype.NtoFixed = function (dp, rm)
    {
        return this.toFixed(dp, rm);
    }

    Decimal.prototype.NtoNearest = function (y, rm)
    {
        return this.toNearest(y, rm).toNumber();
    }

    Decimal.prototype.NtoPrecision = function (sd, rm)
    {
        return this.toPrecision(sd, rm);
    }

    Decimal.prototype.Nnegated = function ()
    {
        return this.negated().toNumber();
    }

    Decimal.prototype.Ntruncate = function (dp)
    {
        return +(this.toFixed(dp, 1));
    }

    Decimal.prototype.NtoFormattedString = function (dp)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        //fill in number of decimal ie: 0.1 to 0.10
        let _value = this.toFixed(dp, 1);

        //fill in thousand seperator
        _value = _value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

        if ($rootScope.CultureKey == 2)
        {
            _value = _value.replace(/,/g, "*");
            _value = _value.replace(/\./g, ",");
            _value = _value.replace(/\*/g, ".");
        }

        return _value;
    }

    Number.prototype.NabsoluteValue = Number.prototype.Nabs = function ()
    {
        return (new Decimal(+this)).absoluteValue().toNumber();
    }

    Number.prototype.Nceil = function ()
    {
        return (new Decimal(+this)).ceil().toNumber();
    }

    Number.prototype.NdividedBy = Number.prototype.Ndiv = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(+this)).dividedBy(new Decimal(+y)).toNumber();
    }

    Number.prototype.Nfloor = function ()
    {
        return (new Decimal(+this)).floor().toNumber();
    }

    Number.prototype.Nminus = Number.prototype.Nsub = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(+this)).minus(new Decimal(+y)).toNumber();
    }

    Number.prototype.Nmodulo = Number.prototype.Nmod = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(+this)).modulo(new Decimal(+y)).toNumber();
    }

    Number.prototype.Nadd = Number.prototype.Nplus = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(+this)).add(new Decimal(+y)).toNumber();
    }

    Number.prototype.Ntimes = Number.prototype.Nmul = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(+this)).times(new Decimal(+y)).toNumber();
    }

    Number.prototype.NtoDecimalPlaces = Number.prototype.NtoDP = function (dp, rm)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        return (new Decimal(+this)).toDecimalPlaces(dp, rm).toNumber();
    }

    Number.prototype.Nadd2 = Number.prototype.Nplus2 = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return ((new Decimal(+this)).add(new Decimal(+y)).toNumber()).NtoDP(2);
    }

    Number.prototype.Ntimes2 = Number.prototype.Nmul2 = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return ((new Decimal(+this)).times(new Decimal(+y)).toNumber()).NtoDP(2);
    }

    Number.prototype.Nminus2 = Number.prototype.Nsub2 = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return ((new Decimal(+this)).minus(new Decimal(+y)).toNumber()).NtoDP(2);
    }

    Number.prototype.NdividedBy2 = Number.prototype.Ndiv2 = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return ((new Decimal(+this)).dividedBy(new Decimal(+y)).toNumber()).NtoDP(2);
    }

    Number.prototype.Nnegated = Number.prototype.Nflip = function ()
    {
        return (new Decimal(+this)).negated().toNumber();
    }

    Number.prototype.Nnegated2 = Number.prototype.Nflip2 = function ()
    {
        return ((new Decimal(+this)).negated().toNumber()).NtoDP(2);
    }

    Number.prototype.NtoFixed = function (dp, rm)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        return (new Decimal(+this)).toFixed(dp, rm);
    }

    Number.prototype.NtoNearest = function (y, rm)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(+this)).toNearest(y, rm).toNumber();
    }

    Number.prototype.NtoPrecision = function (sd, rm)
    {
        if (typeof sd === "undefined" || sd === "" || sd === null)
        {
            sd = 0;
        }

        return (new Decimal(+this)).toPrecision(sd, rm);
    }

    Number.prototype.Ntruncate = function (dp)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        return +((new Decimal(+this)).toFixed(dp, 1));
    }

    Number.prototype.NtoFormattedString = function (dp)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        //fill in number of decimal ie: 0.1 to 0.10
        let _value = (new Decimal(+this)).toFixed(dp, 1);

        //fill in thousand seperator
        _value = _value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

        if ($rootScope.CultureKey == 2)
        {
            _value = _value.replace(/,/g, "*");
            _value = _value.replace(/\./g, ",");
            _value = _value.replace(/\*/g, ".");
        }

        return _value;
    }

    Number.prototype.replace = function (dum1, dum2)
    {
        //console.log("Please fix the part that call this function. This is a dummy function to temporary replace number.replace() method which should not exist.")
        return this.Nadd(0);
    }

    String.prototype.NabsoluteValue = String.prototype.Nabs = function ()
    {
        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).absoluteValue().toNumber();
    }

    String.prototype.Nceil = function ()
    {
        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).ceil().toNumber();
    }

    String.prototype.NdividedBy = String.prototype.Ndiv = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).dividedBy(new Decimal(+y)).toNumber();
    }

    String.prototype.Nfloor = function ()
    {
        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).floor().toNumber();
    }

    String.prototype.Nminus = String.prototype.Nsub = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).minus(new Decimal(+y)).toNumber();
    }

    String.prototype.Nmodulo = String.prototype.Nmod = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).modulo(new Decimal(+y)).toNumber();
    }

    String.prototype.Nadd = String.prototype.Nplus = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).add(new Decimal(+y)).toNumber();
    }

    String.prototype.Ntimes = String.prototype.Nmul = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).times(new Decimal(+y)).toNumber();
    }

    String.prototype.NtoDecimalPlaces = String.prototype.NtoDP = function (dp, rm)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).toDecimalPlaces(dp, rm).toNumber();
    }

    String.prototype.Nadd2 = String.prototype.Nplus2 = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return ((new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).add(new Decimal(+y)).toNumber()).NtoDP(2);
    }

    String.prototype.Ntimes2 = String.prototype.Nmul2 = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return ((new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).times(new Decimal(+y)).toNumber()).NtoDP(2);
    }

    String.prototype.Nminus2 = String.prototype.Nsub2 = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return ((new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).minus(new Decimal(+y)).toNumber()).NtoDP(2);
    }

    String.prototype.NdividedBy2 = String.prototype.Ndiv2 = function (y)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return ((new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).dividedBy(new Decimal(+y)).toNumber()).NtoDP(2);
    }

    String.prototype.Nnegated = String.prototype.Nflip = function ()
    {
        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).negated().toNumber();
    }

    String.prototype.Nnegated2 = String.prototype.Nflip2 = function ()
    {
        return ((new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).negated().toNumber()).NtoDP(2);
    }

    String.prototype.NtoFixed = function (dp, rm)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).toFixed(dp, rm);
    }

    String.prototype.NtoNearest = function (y, rm)
    {
        if (typeof y === "undefined" || y === "" || y === null)
        {
            y = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).toNearest(y, rm).toNumber();
    }

    String.prototype.NtoPrecision = function (sd, rm)
    {
        if (typeof sd === "undefined" || sd === "" || sd === null)
        {
            sd = 0;
        }

        return (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).toPrecision(sd, rm);
    }

    String.prototype.Ntruncate = function (dp)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        return +((new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).toFixed(dp, 1));
    }

    String.prototype.NtoFormattedString = function (dp)
    {
        if (typeof dp === "undefined" || dp === "" || dp === null)
        {
            dp = 0;
        }

        //fill in number of decimal ie: 0.1 to 0.10
        let _value = (new Decimal(this.replace(/,/g, '').trim() == "" ? 0 : this.replace(/,/g, '').trim())).toFixed(dp, 1);

        //fill in thousand seperator
        _value = _value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

        if ($rootScope.CultureKey == 2)
        {
            _value = _value.replace(/,/g, "*");
            _value = _value.replace(/\./g, ",");
            _value = _value.replace(/\*/g, ".");
        }

        return _value;
    }

    function bIgnoreForPrimarySort(iCharCode)
    {
        if (iCharCode < 9) return true;
        if (iCharCode >= 14 && iCharCode <= 31) return true;
        if (iCharCode >= 127 && iCharCode <= 159) return true;
        if (iCharCode == 39 || iCharCode == 45 || iCharCode == 173) return true;

        return false;
    }

    function SortByRoughSQL_Latin1_General_CP1_CS_AS(sA, sB)
    {
        var aSortOrder = [
            -1, 151, 152, 153, 154, 155, 156, 157, 158, 2, 3, 4, 5, 6, 159, 160, 161, 162, 163, 164,
            165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 0, 7, 8, 9, 10, 11, 12, 210,
            13, 14, 15, 41, 16, 211, 17, 18, 65, 69, 71, 74, 76, 77, 80, 81, 82, 83, 19, 20,
            42, 43, 44, 21, 22, 214, 257, 266, 284, 308, 347, 352, 376, 387, 419, 427, 438, 459, 466, 486,
            529, 534, 538, 559, 576, 595, 636, 641, 647, 650, 661, 23, 24, 25, 26, 27, 28, 213, 255, 265,
            283, 307, 346, 350, 374, 385, 418, 426, 436, 458, 464, 485, 528, 533, 536, 558, 575, 594, 635, 640,
            646, 648, 660, 29, 30, 31, 32, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
            190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209,
            1, 33, 53, 54, 55, 56, 34, 57, 35, 58, 215, 46, 59, 212, 60, 36, 61, 45, 72, 75,
            37, 62, 63, 64, 38, 70, 487, 47, 66, 67, 68, 39, 219, 217, 221, 231, 223, 233, 250, 276,
            312, 310, 316, 318, 392, 390, 395, 397, 295, 472, 491, 489, 493, 503, 495, 48, 511, 599, 597, 601,
            603, 652, 590, 573, 218, 216, 220, 230, 222, 232, 249, 275, 311, 309, 315, 317, 391, 389, 394, 396,
            294, 471, 490, 488, 492, 502, 494, 49, 510, 598, 596, 600, 602, 651, 589, 655, 229, 228, 227, 226,
            235, 234, 268, 267, 272, 271, 270, 269, 274, 273, 286, 285, 290, 287, 324, 323, 322, 321, 314, 313,
            326, 325, 320, 319, 358, 357, 362, 361, 356, 355, 364, 363, 378, 377, 380, 379, 405, 404, 403, 402,
            401, 400, 407, 406, 393, 388, 417, 416, 421, 420, 432, 431, 428, 440, 439, 447, 446, 444, 443, 442,
            441, 450, 449, 468, 467, 474, 473, 470, 469, 477, 484, 483, 501, 500, 499, 498, 507, 506, 527, 526,
            540, 539, 544, 543, 542, 541, 561, 560, 563, 562, 567, 566, 565, 564, 580, 579, 578, 577, 593, 592,
            611, 610, 609, 608, 607, 606, 613, 612, 617, 616, 615, 614, 643, 642, 654, 653, 656, 663, 662, 665,
            664, 667, 666, 574, 258, 260, 262, 261, 264, 263, 281, 278, 277, 304, 292, 289, 288, 297, 335, 337,
            332, 348, 349, 369, 371, 382, 415, 409, 434, 433, 448, 451, 462, 476, 479, 509, 521, 520, 524, 523,
            531, 530, 552, 572, 571, 569, 570, 583, 582, 581, 585, 632, 631, 634, 638, 658, 657, 669, 668, 673,
            677, 676, 678, 73, 79, 78, 680, 644, 50, 51, 52, 40, 303, 302, 301, 457, 456, 455, 482, 481,
            480, 225, 224, 399, 398, 497, 496, 605, 604, 626, 625, 620, 619, 624, 623, 622, 621, 334, 241, 240,
            237, 236, 254, 253, 366, 365, 360, 359, 430, 429, 505, 504, 515, 514, 675, 674, 422, 300, 299, 298,
            354, 353, 84, 85, 86, 87, 239, 238, 252, 251, 513, 512, 243, 242, 245, 244, 328, 327, 330, 329,
            411, 410, 413, 412, 517, 516, 519, 518, 547, 546, 549, 548, 628, 627, 630, 629, 88, 89, 90, 91,
            92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111,
            112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131,
            132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 246, 247, 248, 259, 279, 280, 293, 291,
            339, 336, 338, 331, 340, 341, 342, 423, 367, 373, 351, 370, 372, 383, 381, 384, 408, 414, 386, 445,
            453, 452, 454, 461, 463, 460, 475, 478, 465, 508, 522, 525, 532, 550, 553, 554, 555, 545, 556, 557,
            537, 551, 568, 333, 424, 343, 344, 586, 584, 618, 633, 637, 639, 645, 659, 649, 670, 671, 672, 679,
            681, 682, 683, 282, 686, 256, 345, 368, 375, 425, 435, 437, 535, 684, 685, 305, 296, 306, 591, 587,
            588, 144, 145, 146, 147, 148, 149, 150
        ];

        var iLenA = sA.length, iLenB = sB.length;
        var jA = 0, jB = 0;
        var sIgnoreBuff_A = [], sIgnoreBuff_B = [];

        function iSortIgnoreBuff()
        {
            var iIgLenA = sIgnoreBuff_A.length, iIgLenB = sIgnoreBuff_B.length;
            var kA = 0, kB = 0;

            while (kA < iIgLenA && kB < iIgLenB)
            {
                var igA = sIgnoreBuff_A[kA++], igB = sIgnoreBuff_B[kB++];

                if (aSortOrder[igA] > aSortOrder[igB]) return 1;
                if (aSortOrder[igA] < aSortOrder[igB]) return -1;
            }

            if (iIgLenA > iIgLenB) return 1;
            if (iIgLenA < iIgLenB) return -1;

            return 0;
        }

        while (jA < iLenA && jB < iLenB)
        {
            var cA = sA.charCodeAt(jA++);
            var cB = sB.charCodeAt(jB++);

            if (cA == cB)
            {
                continue;
            }

            while (bIgnoreForPrimarySort(cA))
            {
                sIgnoreBuff_A.push(cA);
                if (jA < iLenA)
                    cA = sA.charCodeAt(jA++);
                else
                    break;
            }
            while (bIgnoreForPrimarySort(cB))
            {
                sIgnoreBuff_B.push(cB);
                if (jB < iLenB)
                    cB = sB.charCodeAt(jB++);
                else
                    break;
            }

            if (bIgnoreForPrimarySort(cA))
            {
                if (!bIgnoreForPrimarySort(cB)) return -1;
            }
            else if (bIgnoreForPrimarySort(cB))
            {
                return 1;
            }
            else
            {
                if (aSortOrder[cA] > aSortOrder[cB])
                    return 1;

                if (aSortOrder[cA] < aSortOrder[cB])
                    return -1;

                var iBuffSort = iSortIgnoreBuff();
                if (iBuffSort) return iBuffSort;

                sIgnoreBuff_A = [];
                sIgnoreBuff_B = [];
            }
        }

        var iBuffSort = iSortIgnoreBuff();
        if (iBuffSort) return iBuffSort;

        if (iLenA > iLenB) return 1;
        if (iLenA < iLenB) return -1;

        return 0;
    }

    function _dynamicSort(property)
    {
        var sortOrder = 1;
        if (property[0] === "-")
        {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b)
        {
            var result =
                (a[property] == null && b[property] == null) ? 0 :
                    (a[property] == null) ? -1 :
                        (b[property] == null) ? 1 :
                            (a[property].localeCompare) ? a[property].localeCompare(b[property]) :
                                //SortByRoughSQL_Latin1_General_CP1_CS_AS(a[property], b[property])
                                ((a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0);

            return result * sortOrder;
        }
    }

    function _dynamicSortMultiple(attr)
    {
        /*
         * save the arguments object as it will be overwritten
         * note that arguments object is an array-like object
         * consisting of the names of the properties to sort by
         */
        var props = arguments;
        return function (obj1, obj2)
        {
            var i = 0, result = 0, numberOfProperties = props.length;
            /* try getting a different result from 0 (equal)
             * as long as we have extra properties to compare
             */
            while (result === 0 && i < numberOfProperties)
            {
                result = _dynamicSort(props[i])(obj1, obj2);
                i++;
            }
            return result;
        }
    }

    Array.prototype.sortBy = function ()
    {
        return this.sort(_dynamicSortMultiple.apply(null, arguments));
    }
}]);

//custom string formatter
angular.module('stringFormatterModule', []).filter('stringFormat', function ()
{
    // function _toFormattedString is based on String.js from https://ajaxcontroltoolkit.codeplex.com/SourceControl/latest#Client/MicrosoftAjax/Extensions/String.js
    // as seen in https://stackoverflow.com/questions/2534803/string-format-in-javascript
    function toFormattedString(useLocale, format, values)
    {
        var result = '';

        for (var i = 0; ;)
        {
            // Find the next opening or closing brace
            var open = format.indexOf('{', i);
            var close = format.indexOf('}', i);
            if ((open < 0) && (close < 0))
            {
                // Not found: copy the end of the string and break
                result += format.slice(i);
                break;
            }
            if ((close > 0) && ((close < open) || (open < 0)))
            {
                if (format.charAt(close + 1) !== '}')
                {
                    throw new Error('format stringFormatBraceMismatch');
                }

                result += format.slice(i, close + 1);
                i = close + 2;
                continue;
            }

            // Copy the string before the brace
            result += format.slice(i, open);
            i = open + 1;

            // Check for double braces (which display as one and are not arguments)
            if (format.charAt(i) === '{')
            {
                result += '{';
                i++;
                continue;
            }

            if (close < 0) throw new Error('format stringFormatBraceMismatch');

            // Find the closing brace

            // Get the string between the braces, and split it around the ':' (if any)
            var brace = format.substring(i, close);
            var colonIndex = brace.indexOf(':');
            var argNumber = parseInt((colonIndex < 0) ? brace : brace.substring(0, colonIndex), 10);

            if (isNaN(argNumber)) throw new Error('format stringFormatInvalid');

            var argFormat = (colonIndex < 0) ? '' : brace.substring(colonIndex + 1);

            var arg = values[argNumber];
            if (typeof (arg) === "undefined" || arg === null)
            {
                arg = '';
            }

            // If it has a toFormattedString method, call it.  Otherwise, call toString()
            if (arg.toFormattedString)
            {
                result += arg.toFormattedString(argFormat);
            } else if (useLocale && arg.localeFormat)
            {
                result += arg.localeFormat(argFormat);
            } else if (arg.format)
            {
                result += arg.format(argFormat);
            } else
                result += arg.toString();

            i = close + 1;
        }

        return result;
    };

    return function (/*string*/template, /*array*/values)
    {
        if (!values || !values.length || !template)
        {
            return template;
        }
        return toFormattedString(false, template, values);
    };
});

//global setting/configuration
app.run(['$rootScope', '$log', function ($rootScope, $log)
{
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error)
    {
        event.preventDefault();
        $log.error(error);
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams)
    {
        if (toState.name === "main.subs")
        {
            //if from "/home" to "/home", force it back to "/" to gain time for token and chathub to start
            let urlPath = window.location.href;
            if (urlPath.indexOf("/home") > -1)
            {
                window.location.replace(urlPath.substring(0, urlPath.indexOf("/home") - 1));
                event.preventDefault();
            }
        }

        return;
    });

    $rootScope.chatHubAppVersion = chatHubAppVersion;

    $rootScope.tabLimit = 10;
    $rootScope.powerBItabLimit = 5;
    $rootScope.bookmarkLimit = 200;
    $rootScope.codeMaxLength = 10;
    $rootScope.descMaxLength = 100;
    $rootScope.remarksMaxLength = 200;
    $rootScope.gridMaximumSize = 200;
    $rootScope.comboBoxPageSize =
        (typeof navigator?.deviceMemory === "number" && typeof navigator?.hardwareConcurrency === "number") ?
            (//navigator.deviceMemory >= 8 && navigator.hardwareConcurrency >= 12 ? 500 :
                navigator.deviceMemory >= 8 && navigator.hardwareConcurrency >= 8 ? 400 :
                    navigator.deviceMemory >= 4 && navigator.hardwareConcurrency >= 4 ? 300 :
                        navigator.deviceMemory >= 2 && navigator.hardwareConcurrency >= 2 ? 200 :
                            100) : 100;
    //console.log("Estimated memory : " + (navigator?.deviceMemory ?? 0) + " GB\nEstimated CPU : " + (navigator?.hardwareConcurrency ?? 0) + " core(s)\nCombobox page size : " + $rootScope.comboBoxPageSize);
    $rootScope.notificationReady = false;

    $rootScope.RecordTypes = {
        User: 0,
        System: 1
    };

    $rootScope.RowState = {
        Unchanged: 0,
        Added: 1,
        Modified: 2,
        Deleted: 3
    };

    $rootScope.SupportedLanguages = {
        Default: 0,
        English: 1,
        Malay: 2,
        Indonesia: 3
    }

    $rootScope.MsgIcon = {
        NONE: 0,
        SUCCESS: 1,
        WARNING: 2,
        ERROR: 3,
        QUESTION: 4,
        INFORMATION: 5
    }

    $rootScope.MsgType = {
        NONE: 0,
        OK: 1,
        OKCANCEL: 2,
        YESNOCANCEL: 3,
        CONFIRMCANCEL: 4,
        QCAPPROVALCUSTOM: 5,
        TRANSFEROU: 6
    }

    $rootScope.StockType = {
        NONE: 0,
        STOCK: 1,
        NONSTOCK: 2
    }

    $rootScope.AttachmentSubjects = {
        PurchaseRequisition: 1,
        PurchaseOrder: 2,
        StockReceipt: 3,
        BankPayment: 13,
        PurchaseInvoice: 14,
        SelfBilledInvoiceReceipt: 15,
        CreditNote: 16,
        DebitNote: 17,
        BankReceipt: 18,
        CashReceipt: 19,
        CashPayment: 20,
        CreditorPayment: 21,
        AccMigrationJournal: 22,
        DebtPaymentRcv: 23,
        GeneralJournal: 24,
        SelfBilledInvoice: 25,
        SalesInvoice: 26,
        GSTConsolidation: 27,
        TransactionClearing: 28,
        YearEndAdjustment: 29,
        StockAdjustment: 30,
        StockPurchaseReceipt: 31,
        StockPurchaseRtn: 32,
        StockIssueRtn: 33,
        StockIssue: 34,
        InterOUStockTransfOut: 35,
        StockTransfer: 36,
        StockTake: 37,
        InterOUStockIssue: 38,
        StockMigration: 39,
        UncultivatedArea: 40,
        BankReconciliation: 41,
        Staff: 49,
        Notification: 50,
        StockForwarding: 56,
        CapexRequisition: 57,
        JobReceipt: 58,
        Quotation: 59,
        SumQuotation: 60,
        DailyFFBProcurementRate: 61,
        JobOrder: 62,
        AddVote: 63,
        ProdStockAdjustment: 64,
        StockReq: 65,
        PurchaseRequisitionCode: "PR",
        PurchaseOrderCode: "PO",
        StockReceiptCode: "SR",
        BankPaymentCode: "BP",
        PurchaseInvoiceCode: "PI",
        SelfBilledInvoiceReceiptCode: "SBR",
        CreditNoteCode: "CN",
        DebitNoteCode: "DN",
        BankReceiptCode: "BR",
        CashReceiptCode: "CR",
        CashPaymentCode: "CP",
        CreditorPaymentCode: "CRP",
        AccMigrationJournalCode: "DM",
        DebtPaymentRcvCode: "DRP",
        GeneralJournalCode: "GJ",
        SelfBilledInvoiceCode: "SB",
        SalesInvoiceCode: "SI",
        GSTConsolidationCode: "TD",
        TransactionClearingCode: "CT",
        YearEndAdjustmentCode: "AJ",
        StockAdjustmentCode: "ADJ",
        StockPurchaseReceiptCode: "RCV",
        StockPurchaseRtnCode: "RTN",
        StockIssueRtnCode: "ISURTN",
        StockIssueCode: "ISU",
        InterOUStockTransfOutCode: "OUTRN",
        StockTransferCode: "TRN",
        StockTakeCode: "STOCHK",
        InterOUStockIssueCode: "OUISU",
        StockMigrationCode: "MIG",
        UncultivatedAreaCode: "UNCULAREA",
        BankReconciliationCode: "BANKRECON",
        StaffCode: "EMPY",
        NotificationCode: "NTFY",
        StockForwardingCode: "FWD",
        CapexRequisitionCode: "XR",
        JobReceiptCode: "JR",
        QuotationCode: "QRF",
        SumQuotationCode: "QRS",
        DailyFFBProcurementRateCode: "DFPR",
        JobOrderCode: "JO",
        AddVoteCode: "AV",
        ProdStockAdjustmentCode: "PADJ",
        StockReqCode: "SRQ",
    }

    //Add on feature here (Retired 27/02/2024)
    //$rootScope.AddOnTypes = {
    //    CC: 1, // Multi Company - For example
    //    CRNI: "CRNI", // CRNI Feature
    //    SV: "SV", // Stock Valuation Feature
    //    NSHS: "NSHS", // New Scout Harvesting Setting
    //    ASITEC: "ASITEC", // Automated Stock Issue to Employee/Customer
    //    ESS: "ESS", // Enable ESS
    //    TIMEATTD: "TIMEATTD", //Quarto CheckIn
    //    FARM: "FARM", //Quarto Farm,
    //    SND: "SND", //Sales and distribution
    //    QCONNECT: "QCONNECT", //Quarto Connect
    //    QFACE: "QFACE", //Quarto Face Recognition
    //    ICB: "ICB", //Inter Comp Billing
    //    VLP: "VLP", // Vacation Leave Pay, //Inter Comp Billing
    //    ADVBGT: "ADVBGT", // Advance Budget
    //    QCONNECTI: "QCONNECTI", //Quarto Connect Indonesia
    //    QFRESTRICT: "QFRESTRICT", //Quarto Form Restriction
    //    BUCON: "BUCON", //Sales Invoice Bulk
    //    QPAYCHECK: "QPAYCHECK" // Quarto Paycheck Collection
    //};

    //Keep track of all tabs
    $rootScope.tabList = [];
}]);

//all module/domain's url
app.run(['$rootScope', function ($rootScope)
{
    $rootScope.appName = "Quarto";
    $rootScope.httpName = location.protocol + "//";

    let urlPath = window.location.href;

    //determine environment based on main page's url
    $rootScope.isLocal = urlPath.contains("localhost:31001");
    $rootScope.isDev = urlPath.contains("iquartoweb.azurewebsites.net") || urlPath.contains("dev.quarto.cloud");
    $rootScope.isQA = urlPath.contains("qaquartoweb-qa.azurewebsites.net") || urlPath.contains("qa.quarto.cloud");
    $rootScope.isLiveProd = urlPath.contains("llive-quartoweb.azurewebsites.net") || urlPath.contains("www.quarto.cloud");
    $rootScope.isLivePreProd = urlPath.contains("llive-quartoweb-pre-live.azurewebsites.net") || urlPath.contains("pre-live.quarto.cloud");

    //determine environment for blob storage
    $rootScope.environment = "local";
    $rootScope.environment = $rootScope.isLocal ? "local" : $rootScope.environment;
    $rootScope.environment = $rootScope.isDev ? "dev" : $rootScope.environment;
    $rootScope.environment = $rootScope.isQA ? "qaa" : $rootScope.environment;
    $rootScope.environment = $rootScope.isLiveProd ? "live" : $rootScope.environment;
    $rootScope.environment = $rootScope.isLivePreProd ? "pre-live" : $rootScope.environment;

    $rootScope.domainUrls = {
        Admin: [],
        BudgetFA: [],
        Checkroll: [],
        CheckrollInd: [],
        Dashboard: [],
        Farm: [],
        Finance: [],
        GIS: [],
        InventoryProcurement: [],
        Master: [],
        MillProduction: [],
        NurseryVehicle: [],
        Payroll: [],
        Quarto: [],
        Report: [],
        System: [],
        Workflow: [],
        Reconfigure: () => { },
        //let domain group to be randomly picked, true => sub instance, false => main instance
        DNSGroup: (Math.floor(Math.random() * 2) == 0)
    };

    if ($rootScope.isLocal)
    {
        if (isSingleHost)
        {
            $rootScope.domainUrls.Admin.push("localhost:53786");
            $rootScope.domainUrls.BudgetFA.push("localhost:53786");
            $rootScope.domainUrls.Checkroll.push("localhost:53786");
            $rootScope.domainUrls.CheckrollInd.push("localhost:53786");
            $rootScope.domainUrls.Dashboard.push("localhost:53786");
            $rootScope.domainUrls.Farm.push("localhost:53786");
            $rootScope.domainUrls.Finance.push("localhost:53786");
            $rootScope.domainUrls.GIS.push("localhost:53786");
            $rootScope.domainUrls.InventoryProcurement.push("localhost:53786");
            $rootScope.domainUrls.Master.push("localhost:53786");
            $rootScope.domainUrls.MillProduction.push("localhost:53786");
            $rootScope.domainUrls.NurseryVehicle.push("localhost:53786");
            $rootScope.domainUrls.Payroll.push("localhost:53786");
            $rootScope.domainUrls.Quarto.push("localhost:53786");
            $rootScope.domainUrls.Report.push("localhost:53786");
            $rootScope.domainUrls.System.push("localhost:53786");
            $rootScope.domainUrls.Workflow.push("localhost:51554");
        }
        else
        {
            $rootScope.domainUrls.Admin.push("localhost:50002");
            $rootScope.domainUrls.BudgetFA.push("localhost:38002");
            $rootScope.domainUrls.Checkroll.push("localhost:37002");
            $rootScope.domainUrls.CheckrollInd.push("localhost:49002");
            $rootScope.domainUrls.Dashboard.push("localhost:47003");
            $rootScope.domainUrls.Farm.push("localhost:55002");
            $rootScope.domainUrls.Finance.push("localhost:33002");
            $rootScope.domainUrls.GIS.push("localhost:48002");
            $rootScope.domainUrls.InventoryProcurement.push("localhost:35002");
            $rootScope.domainUrls.Master.push("localhost:30002");
            $rootScope.domainUrls.MillProduction.push("localhost:42002");
            $rootScope.domainUrls.NurseryVehicle.push("localhost:41002");
            $rootScope.domainUrls.Payroll.push("localhost:36002");
            $rootScope.domainUrls.Quarto.push("localhost:31002");
            $rootScope.domainUrls.Report.push("localhost:45002");
            $rootScope.domainUrls.System.push("localhost:46002");
            $rootScope.domainUrls.Workflow.push("localhost:51554");
        }
    }
    else if ($rootScope.isDev)
    {
        $rootScope.domainUrls.Admin.push("ilmoneadminapi.azurewebsites.net");
        $rootScope.domainUrls.BudgetFA.push("ilmonebudgetfaapi.azurewebsites.net");
        $rootScope.domainUrls.Checkroll.push("qalmonecheckrollapi.azurewebsites.net");
        $rootScope.domainUrls.CheckrollInd.push("qalmonecheckrollindapi.azurewebsites.net");
        $rootScope.domainUrls.Dashboard.push("qalmonenotificationapi.azurewebsites.net");
        $rootScope.domainUrls.Farm.push("qalmonefarmapi.azurewebsites.net");
        $rootScope.domainUrls.Finance.push("ilmonefinanceapi.azurewebsites.net");
        $rootScope.domainUrls.GIS.push("qalmonegisapi.azurewebsites.net");
        $rootScope.domainUrls.InventoryProcurement.push("ilmoneinventoryapi.azurewebsites.net");
        $rootScope.domainUrls.Master.push("qalmonemasterapi.azurewebsites.net");
        $rootScope.domainUrls.MillProduction.push("qalmonemillprodapi.azurewebsites.net");
        $rootScope.domainUrls.NurseryVehicle.push("ilmonenurseryapi.azurewebsites.net");
        $rootScope.domainUrls.Payroll.push("ilmonepayrollapi.azurewebsites.net");
        $rootScope.domainUrls.Quarto.push("qaquartoapi.azurewebsites.net");
        $rootScope.domainUrls.Report.push("qalmonereportapi.azurewebsites.net");
        $rootScope.domainUrls.System.push("ilmonesystemapi.azurewebsites.net");
        $rootScope.domainUrls.Workflow.push("lmoneworkflowdev.azurewebsites.net");
    }
    else if ($rootScope.isQA)
    {
        if (isSingleHost)
        {
            $rootScope.domainUrls.Admin.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.BudgetFA.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Checkroll.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.CheckrollInd.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Dashboard.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Farm.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Finance.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.GIS.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.InventoryProcurement.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Master.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.MillProduction.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.NurseryVehicle.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Payroll.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Quarto.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Report.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.System.push("iquartoapi-qa.azurewebsites.net");
            $rootScope.domainUrls.Workflow.push("lmoneworkflowdev-qa.azurewebsites.net");
            $rootScope.domainUrls.Workflow.push("lmoneworkflowdev-qad.azurewebsites.net");
        }
        else
        {
            $rootScope.domainUrls.Admin.push("qaappgw.quarto.cloud/adminapi");
            $rootScope.domainUrls.BudgetFA.push("qaappgw.quarto.cloud/budgetfaapi");
            $rootScope.domainUrls.Checkroll.push("qaappgw.quarto.cloud/checkrollapi");
            $rootScope.domainUrls.CheckrollInd.push("qaappgw.quarto.cloud/checkrollindapi");
            $rootScope.domainUrls.Dashboard.push("qaappgw.quarto.cloud/znotificationapi");
            $rootScope.domainUrls.Farm.push("qaappgw.quarto.cloud/farmapi");
            $rootScope.domainUrls.Finance.push("qaappgw.quarto.cloud/financeapi");
            $rootScope.domainUrls.GIS.push("qaappgw.quarto.cloud/gisapi");
            $rootScope.domainUrls.InventoryProcurement.push("qaappgw.quarto.cloud/zinventoryapi");
            $rootScope.domainUrls.Master.push("qaappgw.quarto.cloud/zmasterapi");
            $rootScope.domainUrls.MillProduction.push("qaappgw.quarto.cloud/millapi");
            $rootScope.domainUrls.NurseryVehicle.push("qaappgw.quarto.cloud/nurseryapi");
            $rootScope.domainUrls.Payroll.push("qaappgw.quarto.cloud/payrollapi");
            $rootScope.domainUrls.Quarto.push("qaappgw.quarto.cloud:8081/quartoapi");
            $rootScope.domainUrls.Report.push("qaappgw.quarto.cloud/reportapi");
            $rootScope.domainUrls.Report.push("qaappgw.quarto.cloud/reportqadapi");
            $rootScope.domainUrls.System.push("qaappgw.quarto.cloud/systemapi");
            $rootScope.domainUrls.Workflow.push("qaappgw.quarto.cloud:8082/workflowapi");
        }
    }
    else if ($rootScope.isLivePreProd)
    {
        $rootScope.domainUrls.Admin.push("llive-adminapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.BudgetFA.push("llive-budgetfaapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Checkroll.push("llive-checkrollapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.CheckrollInd.push("llive-checkrollindapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Dashboard.push("llive-notificationapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Farm.push("llive-farmapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Finance.push("llive-financeapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.GIS.push("ilive-gisapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.InventoryProcurement.push("llive-inventoryapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Master.push("llive-masterapi-pre-live-login.azurewebsites.net");
        $rootScope.domainUrls.Master.push("llive-masterapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.MillProduction.push("llive-millprodapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.NurseryVehicle.push("llive-nurseryapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Payroll.push("llive-payrollapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Quarto.push("llive-quartoapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Report.push("llive-reportapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.System.push("llive-systemapi-pre-live.azurewebsites.net");
        $rootScope.domainUrls.Workflow.push("llive-lmoneworkflow-pre-live.azurewebsites.net");
    }
    else if ($rootScope.isLiveProd)
    {
        $rootScope.domainUrls.Admin.push("quartoappgw.quarto.cloud/adminapi");
        $rootScope.domainUrls.BudgetFA.push("quartoappgw.quarto.cloud/budgetfaapi");
        $rootScope.domainUrls.Checkroll.push("quartoappgw.quarto.cloud/checkrollapi");
        $rootScope.domainUrls.Checkroll.push("quartoappgw.quarto.cloud/checkrollapi");
        $rootScope.domainUrls.CheckrollInd.push("quartoappgw.quarto.cloud/checkrollindapi");
        $rootScope.domainUrls.Dashboard.push("quartoappgw.quarto.cloud/notificationapi");
        $rootScope.domainUrls.Farm.push("quartoappgw.quarto.cloud/farmapi");
        $rootScope.domainUrls.Finance.push("quartoappgw.quarto.cloud/financeapi");
        $rootScope.domainUrls.Finance.push("quartoappgw.quarto.cloud/financeapi");
        $rootScope.domainUrls.GIS.push("quartoappgw.quarto.cloud/gisapi");
        $rootScope.domainUrls.InventoryProcurement.push("quartoappgw.quarto.cloud/inventoryapi");
        $rootScope.domainUrls.Master.push("quartoappgw.quarto.cloud//masterloginapi");
        $rootScope.domainUrls.Master.push("quartoappgw.quarto.cloud/masterapi");
        $rootScope.domainUrls.Master.push("quartoappgw.quarto.cloud/masterapi");
        $rootScope.domainUrls.MillProduction.push("quartoappgw.quarto.cloud/millapi");
        $rootScope.domainUrls.NurseryVehicle.push("quartoappgw.quarto.cloud/nurseryapi");
        $rootScope.domainUrls.Payroll.push("quartoappgw.quarto.cloud/payrollapi");
        $rootScope.domainUrls.Quarto.push("quartoappgw.quarto.cloud:8081/quartoapi");
        $rootScope.domainUrls.Report.push("report.quarto.cloud");
        $rootScope.domainUrls.Report.push("report-qad.quarto.cloud");
        $rootScope.domainUrls.Report.push("quartoappgw.quarto.cloud/reportsqadapi");
        $rootScope.domainUrls.System.push("quartoappgw.quarto.cloud/systemapi");
        $rootScope.domainUrls.Workflow.push("quartoappgw.quarto.cloud:8082/workflowapi");
        $rootScope.domainUrls.Workflow.push("quartoappgw.quarto.cloud:8082/workflowapi");

    }
    else
    {
        throw new Error('Unknown Environment');
    }

    $rootScope.urlKnowledgebaseMY_Live = "https://quartodoc.z23.web.core.windows.net";
    $rootScope.urlKnowledgebaseMY_QA = "https://quartodocqa.z23.web.core.windows.net";
    $rootScope.urlKnowledgebaseIND_Live = "https://quartodocind.z23.web.core.windows.net";
    $rootScope.urlKnowledgebaseIND_QA = "https://quartodocindqa.z23.web.core.windows.net";
    $rootScope.urlGeoserver = $rootScope.isLiveProd ? "https://geoserver.quarto.cloud:8443/geoserver/" : "https://geoserver-qa.quarto.cloud:8443/geoserver/"

    $rootScope.getUrlKnowledgebase = (IsMalaysia) => {
        if (IsMalaysia) {
            return $rootScope.isLiveProd ? $rootScope.urlKnowledgebaseMY_Live : $rootScope.urlKnowledgebaseMY_QA;
        }
        //assume indonesia
        return $rootScope.isLiveProd ? $rootScope.urlKnowledgebaseIND_Live : $rootScope.urlKnowledgebaseIND_QA;
    }

    //force enable debug if it is local/dev/qa
    DEBUG = DEBUG || $rootScope.isLocal || $rootScope.isDev || $rootScope.isQA;

    //add log to show whether or not its single host
    D(() => console.log("%cIs single hosting Quarto solution enabled (isSingleHost flag with Host.sln instead of Quarto.sln) : " + (isSingleHost && ($rootScope.isLocal || $rootScope.isDev || $rootScope.isQA)), (isSingleHost && ($rootScope.isLocal || $rootScope.isDev || $rootScope.isQA)) ? 'background:blue;color:#fff' : 'background:red;color:#fff'));

    $rootScope.domainUrls.Reconfigure = (function Reconfigure()
    {
        //switch domain each time configure
        $rootScope.domainUrls.DNSGroup = !$rootScope.domainUrls.DNSGroup;

        D(() => console.log("Domain URLs configured. Currently at DNS group : " + ($rootScope.domainUrls.DNSGroup ? "Main" : "Sub")));

        //set domain
        $rootScope.adminDNS = $rootScope.domainUrls.Admin[0];
        $rootScope.budgetfaDNS = $rootScope.domainUrls.BudgetFA[0];
        $rootScope.crDNS =
            $rootScope.domainUrls.Checkroll.length > 1 && $rootScope.domainUrls.DNSGroup
                ? $rootScope.domainUrls.Checkroll[1]
                : $rootScope.domainUrls.Checkroll[0];
        $rootScope.crindDNS = $rootScope.domainUrls.CheckrollInd[0];
        $rootScope.dashboardDNS = $rootScope.domainUrls.Dashboard[0];
        $rootScope.farmDNS = $rootScope.domainUrls.Farm[0];
        $rootScope.financeDNS =
            $rootScope.domainUrls.Finance.length > 1 && $rootScope.domainUrls.DNSGroup
                ? $rootScope.domainUrls.Finance[1]
                : $rootScope.domainUrls.Finance[0];
        $rootScope.gisDNS = $rootScope.domainUrls.GIS[0];
        $rootScope.invprocDNS = $rootScope.domainUrls.InventoryProcurement[0];
        $rootScope.masterDNSLogin = $rootScope.domainUrls.Master[0];
        $rootScope.masterDNS =
            $rootScope.domainUrls.Master.length > 2 && $rootScope.domainUrls.DNSGroup
                ? $rootScope.domainUrls.Master[2]
                : ($rootScope.domainUrls.Master.length > 1 && (Math.floor(Math.random() * 2) == 0)
                    ? $rootScope.domainUrls.Master[1]
                    : $rootScope.domainUrls.Master[0]);
        $rootScope.millproductionDNS = $rootScope.domainUrls.MillProduction[0];
        $rootScope.nurvehDNS = $rootScope.domainUrls.NurseryVehicle[0];
        $rootScope.prDNS = $rootScope.domainUrls.Payroll[0];
        $rootScope.quartoDNS = $rootScope.domainUrls.Quarto[0];
        $rootScope.reportDNS =
            $rootScope.domainUrls.Report.length > 2 && $rootScope.domainUrls.DNSGroup
                ? $rootScope.domainUrls.Report[2]
                : ($rootScope.domainUrls.Report.length > 1 && (Math.floor(Math.random() * 2) == 0)
                    ? $rootScope.domainUrls.Report[1]
                    : $rootScope.domainUrls.Report[0]);
        $rootScope.systemDNS = $rootScope.domainUrls.System[0];
        $rootScope.workflowDNS =
            $rootScope.domainUrls.Workflow.length > 1 && $rootScope.domainUrls.DNSGroup
                ? $rootScope.domainUrls.Workflow[1]
                : $rootScope.domainUrls.Workflow[0];

        //login
        $rootScope.masterUrl = $rootScope.httpName + $rootScope.masterDNS + "/";
        $rootScope.masterUrlLogin = $rootScope.httpName + $rootScope.masterDNSLogin + "/";

        //odata
        $rootScope.adminOdataUrl = $rootScope.httpName + $rootScope.adminDNS + "/odata/";
        $rootScope.budgetOdataUrl = $rootScope.httpName + $rootScope.budgetfaDNS + "/budget/odata/";
        $rootScope.crOdataUrl = $rootScope.httpName + $rootScope.crDNS + "/odata/";
        $rootScope.crindOdataUrl = $rootScope.httpName + $rootScope.crindDNS + "/odata/";
        $rootScope.ctrOdataUrl = $rootScope.httpName + $rootScope.prDNS + "/ctr/odata/";
        $rootScope.dashboardOdataUrl = $rootScope.httpName + $rootScope.dashboardDNS + "/dboard/odata/";
        $rootScope.faOdataUrl = $rootScope.httpName + $rootScope.budgetfaDNS + "/fa/odata/";
        $rootScope.farmOdataUrl = $rootScope.httpName + $rootScope.farmDNS + "/odata/";
        $rootScope.financeOdataUrl = $rootScope.httpName + $rootScope.financeDNS + "/odata/";
        $rootScope.gisOdataUrl = $rootScope.httpName + $rootScope.gisDNS + "/odata/";
        $rootScope.inventoryOdataUrl = $rootScope.httpName + $rootScope.invprocDNS + "/inv/odata/";
        $rootScope.mapOdataUrl = $rootScope.httpName + $rootScope.dashboardDNS + "/map/odata/";
        $rootScope.masterOdataUrl = $rootScope.httpName + $rootScope.masterDNS + "/odata/";
        $rootScope.masterOdataUrlLogin = $rootScope.httpName + $rootScope.masterDNSLogin + "/odata/";
        $rootScope.millproductionOdataUrl = $rootScope.httpName + $rootScope.millproductionDNS + "/odata/";
        $rootScope.nurseryOdataUrl = $rootScope.httpName + $rootScope.nurvehDNS + "/nur/odata/";
        $rootScope.prOdataUrl = $rootScope.httpName + $rootScope.prDNS + "/payroll/odata/";
        $rootScope.procureOdataUrl = $rootScope.httpName + $rootScope.invprocDNS + "/proc/odata/";
        $rootScope.quartoOdataUrl = $rootScope.httpName + $rootScope.quartoDNS + "/odata/";
        $rootScope.reportOdataUrl = $rootScope.httpName + $rootScope.reportDNS + "/odata/";
        $rootScope.systemOdataUrl = $rootScope.httpName + $rootScope.systemDNS + "/odata/";
        $rootScope.vehicleOdataUrl = $rootScope.httpName + $rootScope.nurvehDNS + "/veh/odata/";

        //api
        $rootScope.adminWebApiurl = $rootScope.httpName + $rootScope.adminDNS + "/api/";
        $rootScope.budgetWebApiurl = $rootScope.httpName + $rootScope.budgetfaDNS + "/budget/api/";
        $rootScope.crWebApiurl = $rootScope.httpName + $rootScope.crDNS + "/api/";
        $rootScope.crindWebApiurl = $rootScope.httpName + $rootScope.crindDNS + "/api/";
        $rootScope.ctrWebApiurl = $rootScope.httpName + $rootScope.prDNS + "/ctr/api/";
        $rootScope.dashboardWebApiurl = $rootScope.httpName + $rootScope.dashboardDNS + "/dboard/api/";
        $rootScope.faWebApiurl = $rootScope.httpName + $rootScope.budgetfaDNS + "/fa/api/";
        $rootScope.farmWebApiurl = $rootScope.httpName + $rootScope.farmDNS + "/api/";
        $rootScope.financeWebApiUrl = $rootScope.httpName + $rootScope.financeDNS + "/api/";
        $rootScope.giswebApiurl = $rootScope.httpName + $rootScope.gisDNS + "/api/";
        $rootScope.inventoryWebApiurl = $rootScope.httpName + $rootScope.invprocDNS + "/inv/api/";
        $rootScope.mapWebApiurl = $rootScope.httpName + $rootScope.dashboardDNS + "/map/api/";
        $rootScope.masterWebApiUrl = $rootScope.httpName + $rootScope.masterDNS + "/api/";
        $rootScope.millproductionWebApiurl = $rootScope.httpName + $rootScope.millproductionDNS + "/api/";
        $rootScope.notificationWebApiurl = $rootScope.httpName + $rootScope.dashboardDNS + "/noti/api/";
        $rootScope.nurseryWebApiurl = $rootScope.httpName + $rootScope.nurvehDNS + "/nur/api/";
        $rootScope.prWebApiurl = $rootScope.httpName + $rootScope.prDNS + "/payroll/api/";
        $rootScope.procureWebApiurl = $rootScope.httpName + $rootScope.invprocDNS + "/proc/api/";
        $rootScope.quartoWebApiurl = $rootScope.httpName + $rootScope.quartoDNS + "/api/";
        $rootScope.reportWebApiurl = $rootScope.httpName + $rootScope.reportDNS + "/api/";
        $rootScope.systemWebApiurl = $rootScope.httpName + $rootScope.systemDNS + "/api/";
        $rootScope.vehicleWebApiurl = $rootScope.httpName + $rootScope.nurvehDNS + "/veh/api/";

        return Reconfigure;
    }());
}]);

//run AppVersion checking periodically.
app.run(function (signalRService, $interval)
{
    // immediately check for AppVersion on Quarto loaded. (even before login, will use HTTP GET method)
    signalRService.checkAppVersion();

    $interval(function ()
    {
        signalRService.checkAppVersion();
    }, chatHubAppVersionCheckInterval);
});

//configure pages
app.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider)
{
    $stateProvider.state("login", {
        views: {
            'main': {
                templateUrl: "app/views/login.html",
                controller: "loginController as login",
                resolve: {
                    login: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "login",
                            files: ["app/controllers/loginController.js"]
                        });
                    }]
                }
            }
        },
        url: "/login",
    }).state("reset", {
        views: {
            'main': {
                templateUrl: "app/views/reset.html",
                controller: "resetController as reset",
                resolve: {
                    reset: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "reset",
                            files: ["app/controllers/resetController.js"]
                        });
                    }]
                }
            }
        },
        url: "/reset",
    }).state("showConcurrentUser", {
        views: {
            'main': {
                templateUrl: "app/views/errorDetail.html",
                controller: "errorDetailController as showConcurrentUser",
                resolve: {
                    showConcurrentUser: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "showConcurrentUser",
                            files: ["app/controllers/errorDetailController.js"]
                        });
                    }]
                }
            }
        },
        url: "/showConcurrentUser",
    }).state("resetPassword", {
        views: {
            'main': {
                templateUrl: "app/views/resetPassword.html",
                controller: "resetPasswordController as resetPassword",
                resolve: {
                    reset: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "resetPassword",
                            files: ["app/controllers/resetPasswordController.js"]
                        });
                    }]
                }
            }
        },
        url: "/resetPassword",
    }).state("linksent", {
        views: {
            'main': {
                templateUrl: "app/views/linksent.html",
                controller: "linksentController as linksent",
                resolve: {
                    linksent: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "linksent",
                            files: ["app/controllers/linksentController.js"]
                        });
                    }]
                }
            }
        },
        url: "/linksent",
    }).state("unlockUsers", {
        views: {
            'main': {
                templateUrl: "app/views/unlockusers.html",
                controller: "unlockUsersController as linksent",
                resolve: {
                    linksent: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "linksent",
                            files: ["app/controllers/unlockUsersController.js"]
                        });
                    }]
                }
            }
        },
        url: "/unlockusers",
    }).state("main", {
        abstract: true,
        views: {
            'main': {
                templateUrl: "app/views/main.html",
                controller: "mainController as main",
                resolve: {
                    preload: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "main",
                            files: ["app/controllers/mainController.js"]
                        }).then(function ()
                        {
                            return Promise.all([
                                $ocLazyLoad.load({
                                    name: "logoffjs",
                                    serie: true,
                                    files: ["app/views/logoff.html", "app/controllers/logoffController.js"],
                                }),
                                $ocLazyLoad.load({
                                    name: "loginjs",
                                    serie: true,
                                    files: ["app/views/login.html", "app/controllers/loginController.js"],
                                }),
                                $ocLazyLoad.load({
                                    name: "side",
                                    serie: true,
                                    files: ["app/views/side.html", "app/controllers/sideController.js"],
                                }),
                                $ocLazyLoad.load({
                                    name: "nav",
                                    serie: true,
                                    files: ["app/views/nav.html", "app/controllers/navController.js"],
                                }),
                                $ocLazyLoad.load({
                                    name: "kendo.directives",
                                    files: [
                                        "scripts/js/cultures/kendo.culture.id-ID.min.js",
                                        "scripts/js/cultures/kendo.culture.en-MY.min.js",
                                        "scripts/js/cultures/kendo.culture.es-ES.min.js"
                                    ],
                                }),
                                $ocLazyLoad.load({
                                    name: "clientAttachment",
                                    files: ["admin/controllers/clientAttachmentController.js"],
                                    rerun: true
                                }),
                                $ocLazyLoad.load({
                                    name: "attachment",
                                    files: ["master/controllers/attachmentController.js"],
                                    rerun: true
                                }),
                                $ocLazyLoad.load({
                                    name: "enterBankReconUnclear",
                                    files: ["finance/controllers/enterBankReconUnclearController.js"],
                                    rerun: true
                                }),
                                $ocLazyLoad.load({
                                    name: "assetAllocation",
                                    files: ["fa/controllers/assetAllocationController.js"],
                                    rerun: true
                                }),
                                $ocLazyLoad.load({
                                    name: "universalParam",
                                    files: ["master/directives/universalParamDirective.js"],
                                    rerun: true
                                }),
                                $ocLazyLoad.load({
                                    name: "compulsoryParam",
                                    files: ["master/directives/compulsoryParamDirective.js"],
                                    rerun: true
                                })
                            ]);
                        });
                    }],
                    main: ['userService', 'displayService', 'usageAnalyticsService', 'preload', function (userService, displayService, usageAnalyticsService, preload)
                    {
                        return new Promise((resolve, reject) =>
                        {
                            Promise.all([
                                //load user setting/preferences
                                userService.setUserSetting(),
                                //start signalR
                                displayService.initialize()
                            ]).then(() =>
                            {
                                //load display information such as menu/label/bookmark/search auto complete
                                displayService.loadInformation().then(() =>
                                {
                                    //set kendo culture
                                    kendo.culture(userService.userSetting.CultureKey == 2 ? "id-ID" : "en-MY");

                                    //set user theme
                                    switch (userService.userSetting.ThemeKey)
                                    {
                                        //workaround for stupid bug where style doesn't apply on some element
                                        case 1:
                                            setActiveStyleSheet("alternate 1"); setActiveStyleSheet("alternate 1");
                                            break;
                                        case 2:
                                            setActiveStyleSheet("alternate 2"); setActiveStyleSheet("alternate 2");
                                            break;
                                        case 3:
                                            setActiveStyleSheet("alternate 3"); setActiveStyleSheet("alternate 3");
                                            break;
                                        case 4:
                                            setActiveStyleSheet("alternate 4"); setActiveStyleSheet("alternate 4");
                                            break;
                                        case 5:
                                            setActiveStyleSheet("alternate 5"); setActiveStyleSheet("alternate 5");
                                            break;
                                        case 6:
                                            setActiveStyleSheet("alternate 6"); setActiveStyleSheet("alternate 6");
                                            break;
                                        case 7:
                                            setActiveStyleSheet("alternate 7"); setActiveStyleSheet("alternate 7");
                                            break;
                                        case 8:
                                            setActiveStyleSheet("alternate 8"); setActiveStyleSheet("alternate 8");
                                            break;
                                        default:
                                            setActiveStyleSheet("alternate 1"); setActiveStyleSheet("alternate 1");
                                            break;
                                    }

                                    //done
                                    resolve();

                                    //optional analytics
                                    usageAnalyticsService.reloadUsageAnalyticsData();
                                }, (err) => reject(err));
                            }, (err) => reject(err));
                        });
                    }],
                    isHideMenu: ['main', function (main)
                    {
                        return false;
                    }]
                }
            }
        },
        url: "/home"
    }).state('main.subs', {
        url: '',
        views: {
            'side@main': {
                templateUrl: "app/views/side.html",
                controller: "sideController as side",
                resolve: {
                    side: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "side",
                            files: ["app/controllers/sideController.js"]
                        });
                    }]
                }
            },
            'nav@main': {
                templateUrl: "app/views/nav.html",
                controller: "navController as nav",
                resolve: {
                    side: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "nav",
                            files: ["app/controllers/navController.js"]
                        })
                    }],
                }
            },
        }
    }).state("logoff", {
        views: {
            'main': {
                templateUrl: "app/views/logoff.html",
                controller: "logoffController as logoff",
                resolve: {
                    logoff: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "logoff",
                            files: ["app/controllers/logoffController.js"]
                        });
                    }]
                }
            }
        },
        url: "/logoff",
    }).state("extend", {
        views: {
            'main': {
                templateUrl: "app/views/extend.html",
                controller: "extendController as extend",
                resolve: {
                    extend: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "extend",
                            files: ["app/controllers/extendController.js"]
                        });
                    }]
                }
            }
        },
        url: "/extend?returnParam&resetPassword&unlockUsers",
    }).state("loading", {
        views: {
            'main': {
                templateUrl: "app/views/loading.html",
                controller: "loadingController as loading",
                resolve: {
                    logoff: ['$ocLazyLoad', function ($ocLazyLoad)
                    {
                        return $ocLazyLoad.load({
                            name: "loginjs",
                            serie: true,
                            files: ["app/views/login.html", "app/controllers/loginController.js"],
                        }).then(function ()
                        {
                            return $ocLazyLoad.load({
                                name: "logoff",
                                files: ["app/controllers/loadingController.js"]
                            });
                        });
                    }]
                }
            }
        },
        url: "/",
    });

    //Direct To Route Not Found?
    $urlRouterProvider.otherwise("/");
}]);

//disable-animation
app.directive('disableAnimation', ['$animate', function ($animate)
{
    return {
        restrict: 'A',
        link: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs)
        {
            $attrs.$observe('disableAnimation', function (value)
            {
                $animate.enabled(!value, $element);
            });
        }]
    }
}]);

//disable-modification
app.directive('disableModification', function ()
{
    return {
        restrict: 'AEC',
        //E for Element name
        //A for Attribute
        //C for Class
        //M for Comment
        priority: 0,
        link: function (scope, element, attrs)
        {
            let observer;
            let watcher = scope.$watch(attrs.disableModification, function ()
            {
                if (scope.$eval(attrs.disableModification) === true)
                {
                    if (observer)
                    {
                        observer.disconnect();
                        observer = undefined;
                    }

                    element.attr('disabled', true);

                    if ($(element).attr('kendo-treeview') === undefined && $(element).attr('kendo-tree-view') === undefined)
                    {
                        observer = new MutationObserver(function (mutationsList, observer)
                        {
                            for (var mutation of mutationsList)
                            {
                                if (mutation.type == 'attributes' && mutation.attributeName == 'disabled')
                                {
                                    //it get re-enabled
                                    //console.log('The ' + mutation.attributeName + ' attribute of ' + mutation.target.id + ' was modified. Current value is ' + mutation.target.getAttribute("disabled"));

                                    if (mutation.target.getAttribute("disabled") !== "disabled")
                                    {
                                        mutation.target.setAttribute("disabled", "disabled");
                                    }
                                }
                            }
                        });

                        observer.observe(element[0], { attributes: true, attributeFilter: ["disabled"] });
                    }
                    else
                    {
                        observer = new MutationObserver(function (mutationsList, observer)
                        {
                            for (var mutation of mutationsList)
                            {
                                if (mutation.target.className.contains("k-checkbox") && mutation.target.getAttribute("disabled") !== "disabled")
                                {
                                    mutation.target.setAttribute("disabled", "disabled");
                                }

                                let mutationChilds = mutation.target.getElementsByTagName('*');

                                for (var j = 0; j < mutationChilds.length; j++)
                                {
                                    if (mutationChilds[j].className.contains("k-checkbox") && mutationChilds[j].getAttribute("disabled") !== "disabled")
                                    {
                                        mutationChilds[j].setAttribute("disabled", "disabled");
                                    }
                                }
                            }
                        });

                        observer.observe(element[0], {
                            attributes: true,
                            childList: true,
                            characterData: true,
                            subtree: true,
                            //attributeFilter: ["disabled"]
                        });
                    }
                }
            });

            scope.$on('$destroy', function ()
            {
                if (observer)
                {
                    observer.disconnect();
                    observer = undefined;
                }

                if (watcher)
                {
                    watcher();
                }
            });
        }
    }
});

//debounce click
app.directive('ngDebounceClick', function ($timeout)
{
    return {
        restrict: 'A',
        scope: {
            eventHandler: '&ngDebounceClick'
        },
        link: function (scope, el, attrs)
        {
            var timeout;
            el.bind('click', function (e)
            {
                $timeout.cancel(timeout);
                timeout = $timeout(function () { scope.eventHandler.apply(this, arguments); }, 250)
                timeout.then(function () { }, function () { }, function () { })
            });
        }
    }
});

//auto grid height resize
app.directive("kendoGrid", function ()
{
    return {
        terminal: true,
        link: function (scope, element, attrs)
        {
            //store reference to main tab
            let tabPanel = element.parents('div[role="tabpanel"]').last()[0];

            if (typeof tabPanel == "undefined")
            {
                //panel not found, ignore, since no container to refer to resize
                return;
            }

            //last known size to reduce excessive resizing
            let lastKnownBoundingRect;
            let lastKnownTabPanelHeight;

            //resize function
            let resize = function ()
            {
                //grid destroyed, ignore
                if (!$(element).data('kendoGrid'))
                {
                    return;
                }
                else
                {
                    let currentBoundingRect = element[0].getBoundingClientRect();
                    let currentTabPanelHeight = tabPanel.clientHeight;

                    //detect when to apply workaround to recover from wrong column width/missing column when refreshing data on grid with locked column
                    let lockedColumn = ($(element).data('kendoGrid')?.columns?.filter(x => x.locked === true && (typeof x.field) === "string")?.map(y => y.field)) ?? [];
                    let isApplyLockedColumnFix = Array.isArray(lockedColumn)
                        && lockedColumn.length > 0
                        && element[0].querySelector(".k-grid-content-locked") != null
                        && $(element[0].querySelector(".k-grid-content-locked")).width() == 0;

                    if ((currentBoundingRect.top == 0
                        && currentBoundingRect.bottom == 0
                        && currentBoundingRect.left == 0
                        && currentBoundingRect.right == 0) || currentTabPanelHeight == 0)
                    {
                        //D(() => console.log(new Date().toISOString()
                        //    + " | Resizing : " + (element[0].id ?? "")
                        //    + " | Ignored due to visibility"));

                        return;
                    }
                    else if (typeof lastKnownBoundingRect != "undefined"
                        && currentBoundingRect.top == lastKnownBoundingRect.top
                        && currentBoundingRect.bottom == lastKnownBoundingRect.bottom
                        && currentBoundingRect.left == lastKnownBoundingRect.left
                        && currentBoundingRect.right == lastKnownBoundingRect.right
                        && typeof lastKnownTabPanelHeight != "undefined"
                        && currentTabPanelHeight == lastKnownTabPanelHeight)
                    {
                        //D(() => console.log(new Date().toISOString()
                        //    + " | Resizing : " + (element[0].id ?? "")
                        //    + " | Ignored due to no changes in size (last known size)"));

                        //apply workaround
                        if (isApplyLockedColumnFix)
                        {
                            //D(() => console.log(new Date().toISOString()
                            //    + " | Resizing : " + (element[0].id ?? "")
                            //    + " | Kendo grid locked column workaround applied"));

                            $(element).data('kendoGrid').unlockColumn(lockedColumn[lockedColumn.length - 1]);
                            $(element).data('kendoGrid').lockColumn(lockedColumn[lockedColumn.length - 1]);
                        }

                        return;
                    }
                    else
                    {
                        //apply workaround
                        if (isApplyLockedColumnFix)
                        {
                            //D(() => console.log(new Date().toISOString()
                            //    + " | Resizing : " + (element[0].id ?? "")
                            //    + " | Kendo grid locked column workaround applied"));

                            $(element).data('kendoGrid').unlockColumn(lockedColumn[lockedColumn.length - 1]);
                            $(element).data('kendoGrid').lockColumn(lockedColumn[lockedColumn.length - 1]);
                        }
                    }

                    //force resize to screen height to calculate overflow
                    element.height(screen.availHeight);

                    let overflow = tabPanel.scrollHeight - tabPanel.clientHeight;
                    let targetHeight = element.height() - overflow - 6;

                    //grid minimum height 250px
                    targetHeight = Math.max(targetHeight, 250);

                    if (element.height() !== targetHeight)
                    {
                        //D(() => console.log(new Date().toISOString()
                        //    + " | Resizing : " + (element[0].id ?? "")
                        //    + " | Tab scroll height : " + tabPanel.scrollHeight
                        //    + " | Tab client height : " + tabPanel.clientHeight
                        //    + " | Overflow : " + overflow
                        //    + " | Element height : " + element.height()
                        //    + " | Grid height : " + ($(element).data('kendoGrid')?._size?.height ?? "")
                        //    + " | Screen height : " + screen.availHeight
                        //    + " | Target height : " + targetHeight
                        //    + "\n"
                        //    + "Last Bounding Rect : Top(" + (lastKnownBoundingRect?.top ?? "") + ") Bottom(" + (lastKnownBoundingRect?.bottom ?? "") + ") Left(" + (lastKnownBoundingRect?.left ?? "") + ") Right(" + (lastKnownBoundingRect?.right ?? "") + ")"
                        //    + " | Current Bounding Rect : Top(" + currentBoundingRect.top + ") Bottom(" + currentBoundingRect.bottom + ") Left(" + currentBoundingRect.left + ") Right(" + currentBoundingRect.right + ")"));

                        element.height(targetHeight);
                        $(element).data('kendoGrid').resize();
                    }
                    else
                    {
                        //D(() => console.log(new Date().toISOString()
                        //    + " | Resizing : " + (element[0].id ?? "")
                        //    + " | Ignored due to no changes in size (target size)"));
                    }

                    lastKnownBoundingRect = currentBoundingRect;
                    lastKnownTabPanelHeight = currentTabPanelHeight;
                }
            }

            //resize function with debounce to prevent excessive resizing
            let debounced_resize = _.debounce(resize, 100, { 'leading': false, 'trailing': true, 'maxWait': 300 });

            //observe for height change
            let observerHeight;

            //observe for grid initialization
            let observerInit = new MutationObserver(() =>
            {
                //if there is detect-height attribute and kendoGrid initialized, then only resize, else keep observe
                if ($(element).data('kendoGrid') === undefined)
                {
                    return;
                }
                else
                {
                    //init once only
                    if (observerInit)
                    {
                        observerInit.disconnect();
                        observerInit = undefined;
                    }

                    //if there is no detect-height attribute, ignore
                    if ($(element).attr('detect-height') === undefined || $(element).attr('detect-height') === false)
                    {
                        return;
                    }

                    //first resize don't debounce
                    resize();

                    setTimeout(() =>
                    {
                        observerHeight = new ResizeObserver(debounced_resize);
                        observerHeight.observe(element[0]);

                        //special handle for UQF
                        let sibling = tabPanel.querySelector(".detectHeaderHeight");
                        if (sibling != null)
                        {
                            observerHeight.observe(sibling);
                        }

                        //add listener to trigger resize
                        //tabPanel.addEventListener('transitionend', debounced_resize);
                        scope.$parent.tabstrip.bind('activate', debounced_resize);
                        $(window).resize(debounced_resize);

                        //remove listener on destroy
                        scope.$on('$destroy', function ()
                        {
                            //tabPanel.removeEventListener('transitionend', debounced_resize);
                            scope.$parent.tabstrip.unbind('activate', debounced_resize);
                            $(window).off('resize', debounced_resize);

                            if (observerHeight)
                            {
                                observerHeight.disconnect();
                                observerHeight = undefined;
                            }
                        });
                    }, 100);
                }
            });

            observerInit.observe(element[0], { subtree: true, childList: true, attributes: true, characterData: true });
        }
    };
});

//auto chart resize
app.directive("kendoChart", function ()
{
    return {
        terminal: true,
        link: function (scope, element, attrs)
        {
            //store reference to main tab
            let tabPanel = element.parents('div[role="tabpanel"]').last()[0];

            if (typeof tabPanel == "undefined")
            {
                //panel not found, ignore, since no container to refer to resize
                return;
            }

            //resize function
            let resize = function ()
            {
                //chart destroyed, ignore
                if (!$(element).data('kendoChart'))
                {
                    return;
                }
                else
                {
                    let currentBoundingRect = element[0].getBoundingClientRect();

                    if ((currentBoundingRect.top == 0
                        && currentBoundingRect.bottom == 0
                        && currentBoundingRect.left == 0
                        && currentBoundingRect.right == 0))
                    {
                        return;
                    }

                    $(element).data('kendoChart').resize();
                }
            }

            //resize function with debounce to prevent excessive resizing
            let debounced_resize = _.debounce(resize, 50, { 'leading': false, 'trailing': true, 'maxWait': 150 });

            //observe for height change
            let observerHeight;

            //observe for grid initialization
            let observerInit = new MutationObserver(() =>
            {
                //if kendoChart initialized, then only resize, else keep observe
                if ($(element).data('kendoChart') === undefined)
                {
                    return;
                }
                else
                {
                    //init once only
                    if (observerInit)
                    {
                        observerInit.disconnect();
                        observerInit = undefined;
                    }

                    //first resize don't debounce
                    resize();

                    setTimeout(() =>
                    {
                        observerHeight = new ResizeObserver(debounced_resize);
                        observerHeight.observe(element[0]);

                        //add listener to trigger resize
                        //tabPanel.addEventListener('transitionend', debounced_resize);
                        $(window).resize(debounced_resize);

                        //remove listener on destroy
                        scope.$on('$destroy', function ()
                        {
                            //tabPanel.removeEventListener('transitionend', debounced_resize);
                            $(window).off('resize', debounced_resize);

                            if (observerHeight)
                            {
                                observerHeight.disconnect();
                                observerHeight = undefined;
                            }
                        });
                    }, 50);
                }
            });

            observerInit.observe(element[0], { subtree: true, childList: true, attributes: true, characterData: true });
        }
    };
});

//auto resize grid to kendo window size
app.directive("kendoWindow", function ()
{
    return {
        //terminal: true,
        link: function (scope, element, attrs)
        {
            //resize function
            let resize = function ()
            {
                let currentBoundingRect = element[0].getBoundingClientRect();

                if ((currentBoundingRect.top == 0
                    && currentBoundingRect.bottom == 0
                    && currentBoundingRect.left == 0
                    && currentBoundingRect.right == 0))
                {
                    //D(() => console.log(new Date().toISOString()
                    //    + " | Resizing : " + (element[0].id ?? "")
                    //    + " | Ignored due to visibility"));

                    return;
                }
                else if (element[0].querySelectorAll("[detect-height-window]").length == 1)
                {
                    //target height
                    let targetHeight = element[0].clientHeight - 50;

                    //grid minimum height 250px
                    targetHeight = Math.max(targetHeight, 250);

                    var kendoGrid = element[0].querySelectorAll("[detect-height-window]")[0];
                    $(kendoGrid).height(targetHeight);
                    $(kendoGrid).data('kendoGrid').resize();
                }
            }

            //resize function with debounce to prevent excessive resizing
            let debounced_resize = _.debounce(resize, 100, { 'leading': false, 'trailing': true, 'maxWait': 300 });

            //observe for window initialization
            let observerInit = new MutationObserver(() =>
            {
                //if kendoWindow initialized, then only resize, else keep observe
                if ($(element).data('kendoWindow') === undefined)
                {
                    return;
                }
                else
                {
                    //init once only
                    if (observerInit)
                    {
                        observerInit.disconnect();
                        observerInit = undefined;
                    }

                    //only enable if there is a single grid set to detect-height-window
                    if (element[0].querySelectorAll("[detect-height-window]").length == 1)
                    {
                        //set minimum window size
                        $(element[0]).data("kendoWindow").setOptions({ minWidth: 720, minHeight: 300 });

                        //first resize don't debounce
                        resize();

                        setTimeout(() =>
                        {
                            var window = $(element[0]).data("kendoWindow");

                            window.bind("resize", debounced_resize);
                            window.bind("activate", debounced_resize);

                            //remove event on destroy
                            scope.$on('$destroy', function ()
                            {
                                window.unbind("resize", debounced_resize);
                                window.unbind("activate", debounced_resize);
                            });
                        }, 50);
                    }
                }
            });

            observerInit.observe(element[0], { subtree: true, childList: true, attributes: true, characterData: true });
        }
    };
});